/* eslint-disable no-underscore-dangle */
import SearchClient from '../search';

export default class UtilsClient extends SearchClient {
  constructor(options = {}) {
    super(options);
  }

  converterTfno = async (data) => {
    try {
      const response = await this.request('post')(
        { data },
        { path: 'telefonos/formatos' },
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
}
